import { Stack, Typography } from "@mui/material";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { isNotNil } from "ramda-adjunct";
import { WorkerRating } from "@sinch/components";
import { StaffHeaderFragment } from "./fragments.types";

/**
 * Worker rating, optionally followed by the configured maximum rating. Renders
 * nothing when the worker has no rating.
 */
export const StaffRating: FC<{ workerinfo: StaffHeaderFragment["workerinfo"] }> = ({ workerinfo }) => {
  const { t } = useTranslation();

  const rating = workerinfo?.rating;
  const maxRating = workerinfo?.maxRating;

  if (!isNotNil(rating)) {
    return null;
  }

  return (
    <Stack
      alignItems="center"
      direction="row"
      gap={0.25}
      sx={({ palette }) => ({ color: palette.grey[500], fontSize: "1.0625rem", marginLeft: "auto" })}
    >
      <WorkerRating includePlus rating={rating} />
      {isNotNil(maxRating) && (
        <>
          /
          <Typography sx={({ palette }) => ({ color: palette.grey[500] })} variant="descriptionTiny">
            <Stack sx={{ lineHeight: 0.8 }}>
              <span>{t("max")}</span>
              <span>{maxRating}</span>
            </Stack>
          </Typography>
        </>
      )}
    </Stack>
  );
};
